import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActiveUser } from '../../../../shared/models';
import {
  getActiveUserInitials,
  formatActiveUserTimestampRelative,
  getActiveUserApplicationLabel,
  getActiveUserFullName,
} from '../../../../shared/utils';

import { ButtonDirective } from 'primeng/button';

export interface MultipleEditorsModalData {
  users: ActiveUser[];
  loanNumber: string;
  showSaveChangesButton?: boolean;
}

export enum MultipleEditorsModalResult {
  OK = 'ok',
  Dismiss = 'dismiss',
  SaveChanges = 'saveChanges',
}

@Component({
  selector: 'cmg-clear2-ui-multiple-editors-modal',
  templateUrl: './multiple-editors-modal.component.html',
  styleUrls: ['./multiple-editors-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class MultipleEditorsModalComponent {
  private readonly _dialogConfig = inject<DynamicDialogConfig<MultipleEditorsModalData>>(DynamicDialogConfig);
  private readonly _dialogRef = inject(DynamicDialogRef);

  users: ActiveUser[] = [];
  loanNumber = '';
  showSaveChangesButton = false;

  constructor() {
    this.users = this._dialogConfig.data?.users ?? [];
    this.loanNumber = this._dialogConfig.data?.loanNumber ?? '';
    this.showSaveChangesButton = this._dialogConfig.data?.showSaveChangesButton ?? false;
  }

  getInitials(user: ActiveUser): string {
    return getActiveUserInitials(user);
  }

  getFullName(user: ActiveUser): string {
    return getActiveUserFullName(user);
  }

  getApplicationLabel(user: ActiveUser): string {
    return getActiveUserApplicationLabel(user);
  }

  getFormattedTimestamp(user: ActiveUser): string {
    return formatActiveUserTimestampRelative(user);
  }

  close(): void {
    this._dialogRef.close(MultipleEditorsModalResult.OK);
  }
}
